export const COMMUNITY_LISTING_ALERT_DISMISSED =
  'communityListingAlertDismissed';
export const NEW_COMMUNITY_LISTING_DOCS_BANNER_DISMISSED =
  'newCommunityListingsDocsBannerDismissed';
export const NOT_SHOW_CLONE_TRANSACTION_CONFIRMATION =
  'notShowCloneTransactionConfirmation';
export const TWO_WAY_SYNC_CONFIRMATION_DISMISSED =
  'twoWaySyncConfirmationDismissed';
export const DOCUMENTS_VIEW_MODE = 'side-documentsViewMode';
export const INTERACTIONS_VIEW_MODE = 'side-interactionsViewMode';
export const INTERACTIONS_COLUMN_VISIBILITY_PREFIX =
  'side-interactionsColumnVisibility';
export const REPORTING_INSIGHTS_INTERACTION_ID =
  'reportingInsightsInteractionId';
export const VALIDATION_BANNER_OPEN_PREFIX = 'validationBannerOpen';
